var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction"},[(_vm.item.params.image)?[_c('img',{attrs:{"src":_vm.item.params.image}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }